<div class="flex flex-row place-content-center items-start">
  <div *ngIf="templateFacade.selectedLanguage$ | async as selectedLanguage"
    class="flex flex-col w-full max-w-screen-2xl pt-8">
    <h1 class="text-white pl-10">Design From Scratch</h1>
    <div class="flex flex-row flex-wrap mb-8 mt-4" *ngIf="!loading" [@simpleFadeAnimation]>
      <div class="w-1/2 sm:w-1/3 flex flex-row place-content-center items-center">
        <a routerLink="/new" [queryParams]="{'from': 'scratch'}">
          <div class="rounded-lg overflow-hidden w-full max-w-xs bg-white mb-9 shadow-xl grow flex flex-col">

            <div class="h-96 w-80 object-cover max-h-96 flex flex-row place-content-center items-center">
              <mat-icon style="font-size:70px;color:#81848a;height:70px;width:70px;">create</mat-icon>
            </div>
            <mat-divider></mat-divider>
            <div class="flex flex-col p-4">
              <div class="flex flex-row place-content-between items-center mb-2">
                <h3 class="text-black font-bold m-0"
                  style="text-decoration:underline;text-decoration-style: double;text-decoration-color: rgb(1,90,156);"
                  fxFlex>Blank</h3>
              </div>

              <span class="text-grey-700">Start from an empty canvas</span>
            </div>
          </div>
        </a>
      </div>
    </div>

    <h1 class="text-white pl-10">Design From Q Templates Gallery</h1>
    <ng-container *ngIf="templateFacade.quorumGallery$ | async as quorumGallery">
      <div class="flex flex-row flex-wrap mb-4 mt-2" *ngIf="!loading" [@simpleFadeAnimation]="quorumGallery.length">
        <ng-container *ngFor="let template of quorumGallery | orderBy: ['name']">
          <div *ngIf="template.languageDefinitionMap[selectedLanguage]" fxFlex="50" fxFlex.gt-md="33.33"
            class="flex flex-row place-content-center items-center">
            <a routerLink="/new"
              [queryParams]="{'from': 'quorumGallery', 'id': template.id, 'language': selectedLanguage}">
              <div class="flex flex-col rounded-lg overflow-hidden w-full max-w-xs bg-white mb-8 shadow-2xl grow">
                <img class="h-auto w-full" [src]="template.languageDefinitionMap[selectedLanguage].previewImageUrl">
                <mat-divider></mat-divider>
                <div class="flex flex-col p-4">
                  <div class="flex flex-row place-content-between items-center mb-1.5">
                    <h3 class="flex-grow font-bold m-0 text-black"
                      style="text-decoration:underline; text-decoration-style: double;text-decoration-color: rgb(1,90,156);">
                      {{template.languageDefinitionMap[selectedLanguage].name}}</h3>
                  </div>
                  <span class="text-grey-600">{{template.languageDefinitionMap[selectedLanguage].description}}</span>
                </div>
              </div>
            </a>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="authenticationStateService.selectAuthenticatedUser() | async as user">
      <h1 class="text-white pl-10">Design From {{user.user.storeName}} Gallery</h1>
      <ng-container *ngIf="templateFacade.storeGallery$ | async as storeGallery">
        <div class="flex flex-row flex-wrap mb-4 mt-2" *ngIf="!loading" [@simpleFadeAnimation]="storeGallery.length">
          <ng-container *ngFor="let template of storeGallery | orderBy: ['name']">

            <div *ngIf="template.languageDefinitionMap[selectedLanguage]" fxFlex="50" fxFlex.gt-md="33.33"
              class="flex flex-row place-content-center items-center">
              <a routerLink="/new"
                [queryParams]="{'from': 'dealerGallery', 'id': template.id, 'language': selectedLanguage}">
                <div class="flex flex-col rounded-lg overflow-hidden w-full max-w-xs bg-white mb-8 shadow-2xl grow">
                  <img class="h-auto w-full" [src]="template.languageDefinitionMap[selectedLanguage].previewImageUrl">
                  <mat-divider></mat-divider>
                  <div class="flex flex-col p-4">
                    <div class="flex flex-row place-content-between items-center mb-1.5">
                      <h3 class="flex-grow font-bold m-0 text-black"
                        style="text-decoration:underline; text-decoration-style: double;text-decoration-color: rgb(1,90,156);">
                        {{template.languageDefinitionMap[selectedLanguage].name}}</h3>
                    </div>
                    <span class="text-grey-600">{{template.languageDefinitionMap[selectedLanguage].description}}</span>
                  </div>
                </div>
              </a>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>